import classes from "./Feedback.module.css";

import { useState } from "react";
import { FaBookmark } from "react-icons/fa6";
import {
  getActiveBranchIds,
  getBranchInfobyId,
} from "../util/multipleBranch/getActiveBranchId";
//this component receives single element of array of data from db

export default function Feedback({ data, bmHandler, branchBrowser }) {
  /** CHECK IPAD for logic of implementing branch button press handler to
   * go to first feedback of that particular branhc
   */

  // console.log("log from feedback single");
  // console.log("XXXXXXX",data);
  let currentFeedbackBranch = data?.admin_id;
  // console.log(data.bookMarked);
  let branches = JSON.parse(localStorage.getItem("branches"));
  const activeBranches = getActiveBranchIds(branches);
  let remarksTitle = JSON.parse(localStorage.getItem("questions")).remarksTitle;

  const activeBranchNames = activeBranches.map((id) => {
    return getBranchInfobyId(id);
  });

  const [activeBranch, setActiveBranch] = useState(activeBranches);

  let date = new Date(data?.createdAt);
  let d1 = date.toLocaleDateString("en-IN");
  let d2 = d1.split("/").reverse().join("/");

  // let nd = date.split("").reverse().join("");
  //console.log(nd);

  // if (!data) {
  //   return;
  // }

  // console.log(data);

  // WORKING ON BRANCH SELECTOR

  function branchSelectHandler(e) {
    branchBrowser(e.target.id);
  }
  if (data == undefined) return null;
  return (
    <>
      <div className={classes.container}>
        <div className={classes.branchSelectorContainer}>
          {branches.length > 1 &&
            activeBranchNames.map((branch) => {
              return (
                <div
                  key={branch.name}
                  className={`${classes.branchButton} ${
                    currentFeedbackBranch == branch.bId &&
                    classes.activeBranchButton
                  }`}
                  onClick={(e) => branchSelectHandler(e)}
                >
                  <p id={branch.bId}>{branch.name}</p>
                </div>
              );
            })}
        </div>
        <div className={classes.toplineInfo}>
          <div
            className={`${
              data.bookMarked ? classes.savedBookmark : classes.bookmark
            }`}
            onClick={() => {
              bmHandler(data._id, !data.bookMarked);
            }}
          >
            <FaBookmark />
          </div>

          <p>Rating : {data?.rating}</p>
          <div className={classes.date}>
            <p>{d1}</p>
          </div>
        </div>
        <div>
          <div className={`${classes.innerContainer}`}>
            <div className={classes.bioDetails}>
              {data?.data?.bioDetails && data?.data?.bioDetails.map((item, index) => {
                return (
                  <div className={classes.optionQuestion} key={`is ${index}`}>
                    <p>
                      <span>{index + 1} .</span>
                      {item.title}
                    </p>
                    <p
                      className={`${classes.optionResponse} ${classes.optionResponse1} `}
                    >
                      {item.answer}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>

          <div className={`  ${classes.innerContainer}`}>
            {data?.data.optionQuestions.map((item, index) => {
              let foodIssueStr = "";
              if (
                item.title != "foodIssue" &&
                item.title != "foodNameHavingIssue"
              ) {
                if (
                  item.title.includes("Food") ||
                  item.title.includes("food")
                ) {
                  let foodIssue = data.data.optionQuestions[0].answer;
                  let foodNameHavingIssue = data.data.optionQuestions[1].answer;
                  foodIssueStr = `${foodNameHavingIssue} :- ${foodIssue}`;

                  return (
                    <div className={classes.optionQuestion} key={`is ${index}`}>
                      <p>
                        <span>{index - 1} .</span>
                        {item.title}
                      </p>
                      <p
                        className={`${classes.optionResponse} ${classes.optionResponse1} `}
                      >
                        {item.answer}
                      </p>
                      {foodIssueStr.length > 5 && (
                        <div className={classes.foodIssueContainer}>
                          {" "}
                          <p className={classes.foodIssue}>
                            {foodIssueStr}
                          </p>{" "}
                        </div>
                      )}
                    </div>
                  );
                } else {
                  return (
                    <div className={classes.optionQuestion} key={`is ${index}`}>
                      <p>
                        <span>{index - 1} .</span>
                        {item.title}
                      </p>
                      <p
                        className={`${classes.optionResponse} ${classes.optionResponse1} `}
                      >
                        {item.answer}
                      </p>
                    </div>
                  );
                }
              }
            })}
          </div>
          <div className={classes.checkQuestions}>
            {/* {data?.data.checkQuestions && <h4>Check mark Questions</h4>} */}
            {data?.data.checkQuestions.map((item, index) => {
              return (
                <div key={`iss ${index}`}>
                  <p>
                    <span>{index + 1} .</span>
                    {item.title}
                  </p>
                  <p>
                    <span>Response : </span>
                    {item.answer}
                  </p>
                  <hr />
                </div>
              );
            })}
          </div>
        </div>
        <div className={`${classes.innerContainer}`}>
          <div className={classes.simpleQuestions}>
             <div className={classes.optionQuestion}  >
                  <p>{remarksTitle}</p>
                  <p
                    className={`${classes.optionResponse} ${classes.optionResponse1} `}
                  >
                    {data.data?.remarks}
                  </p>
                </div>
            {/* {data?.data.simpleQuestions.map((item, index) => {
              return (
                <div className={classes.optionQuestion} key={`is ${index}`}>
                  <p>{item.title}</p>
                  <p
                    className={`${classes.optionResponse} ${classes.optionResponse1} `}
                  >
                    {item.answer}
                  </p>
                </div>
              );
            })} */}
          </div>
        </div>
      </div>
    </>
  );
}
